<template>
  <v-card class="mb-3">
    <div class="order-info">
      <span class="order-info-block">
        <span class="order-label">Ordered</span><br>
        {{order.ordered_at | moment('MM/DD/YYYY hh:mm A [PT]z')}}<br>
        <a :href="'/orders/' + order.id" target="_blank">
          {{order.site_code}}{{order.id}}
        </a>
      </span>
      <span class="order-info-block" v-if="shipped">
        <span class="order-label">Shipped</span><br>
        {{order.shipped_at | moment('MM/DD/YYYY hh:mm A [PT]z')}}<br>
        <a :href="order.shipping_status.shipping_link" target="_blank">
          {{order.shipping_method_short_name || order.shipping_method}}
        </a>
      </span>
      <span class="order-info-block" v-else>
        <span class="order-label">Production</span><br>
        <template v-if="order.processed_at">
          {{order.processed_at | moment('MM/DD/YYYY hh:mm A [PT]z')}}
        </template>
        <template v-else>
          In Queue To Send
        </template>
      </span>
      <span class="order-info-block">
        <span class="order-label">Ship To</span><br>
        {{order.shipping_info.name}}<br>
        {{order.shipping_info.company}}
      </span>
      <span class="order-info-block">
        <span class="order-label">Bill To</span><br>
        {{order.billing_info.name}}<br>
        {{order.billing_info.company}}
      </span>
      <span class="right right-align mt-3">
        <v-btn color="primary" :to="'/reorder/' + order.id">Reorder</v-btn>
      </span>
    </div>
    <template class="order-items" v-if="order.items.length > 0" v-for="item, index in order.items">
      <v-layout v-bind="layout">
        <v-flex xs1 mx-3 mt-2 class="center-align">
          <a :href="item.file.files.preview" target="_blank" v-if="item.file">
            <img class="elevation-3 preview-image responsive-img" :src="item.file.thumbs.small" alt="">
          </a>
        </v-flex>
        <v-flex xs11 pt-3>
          <item-description :item="item" :orderInfo="true"/>
        </v-flex>
      </v-layout>
    </template>
    <template v-if="order.items.length === 0">
      <v-layout row>
        <v-flex xs12 mx-3 mt-2 mb-2>
          No Items Found
        </v-flex>
      </v-layout>
    </template>
  </v-card>
</template>

<style lang="sass" scoped>
.order-info
  border-bottom: solid 1px #ccc

  .order-info-block
    display: inline-block
    margin: 5px 15px
    overflow: hidden
    vertical-align: top
    white-space: nowrap

    .order-label
      font-size: 75%
</style>

<script>
  import ItemDescription from '../widgets/item-description'

  export default {
    props: {
      order: { type: Object, required: true },
      index: { type: Number, required: true }
    },

    components: {
      itemDescription: ItemDescription
    },

    computed: {
      layout () {
        const layout = {}
        if (this.$vuetify.breakpoint.smAndDown) layout.column = true
        return layout
      },

      cart: {
        get () {
          return this.$store.state.cart
        },
        set (value) {
          this.$store.commit('saveCart', value)
        }
      },

      validOrder () {
        return this.order && this.order.items
      },

      delivered () {
        return this.order.delivered_at
      },

      shipped () {
        return this.order.shipped_at
      },

      processed () {
        return this.order.processed_at
      }
    },

    methods: {
      unitPrice (item) {
        if (item.quantity >= 250) return item.unit_prices[250]
        if (item.quantity < 250) return item.unit_prices[100]
        if (item.quantity < 100) return item.unit_prices[5]
        if (item.quantity < 5) return item.unit_prices[1]
      },

      addItem (id, quantity) {
        this.$store.dispatch('addCartItem', {
          'order_item_id': id,
          'quantity': quantity
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// card.vue?0746f95c